"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlSlug = void 0;
//arriendo/casa/metropolitana/santiago/lastarria
//[{"type": "OPERATION_TYPE", "idType": 1}, {"type": "PROPERTY_TYPE", "idType": 2}, {"type": "REGION", "idType": 3}, {"type": "COMMUNE", "idType": 4}, {"type": "NEIGHBORHOOD", "idType": 5}]
var UrlSlug;
(function (UrlSlug) {
    UrlSlug[UrlSlug["CONCEPT"] = 0] = "CONCEPT";
    UrlSlug[UrlSlug["OPERATION_TYPE"] = 1] = "OPERATION_TYPE";
    UrlSlug[UrlSlug["PROPERTY_TYPE"] = 2] = "PROPERTY_TYPE";
    UrlSlug[UrlSlug["REGION"] = 3] = "REGION";
    UrlSlug[UrlSlug["COMMUNE"] = 4] = "COMMUNE";
    UrlSlug[UrlSlug["NEIGHBORHOOD"] = 5] = "NEIGHBORHOOD";
    UrlSlug[UrlSlug["BEDROOMS"] = 6] = "BEDROOMS";
    UrlSlug[UrlSlug["BATHROOMS"] = 7] = "BATHROOMS";
    UrlSlug[UrlSlug["PRICE"] = 8] = "PRICE";
    UrlSlug[UrlSlug["METERS"] = 9] = "METERS";
    UrlSlug[UrlSlug["AREA"] = 10] = "AREA";
    UrlSlug[UrlSlug["YEAR_CONSTRUCTION"] = 11] = "YEAR_CONSTRUCTION";
    UrlSlug[UrlSlug["ATTRIBUTES"] = 12] = "ATTRIBUTES";
    UrlSlug[UrlSlug["CHAIN"] = 13] = "CHAIN";
    UrlSlug[UrlSlug["SUBSIDY"] = 14] = "SUBSIDY";
    UrlSlug[UrlSlug["CLIENT_TYPE"] = 15] = "CLIENT_TYPE";
    UrlSlug[UrlSlug["PROJECT_ORDER"] = 16] = "PROJECT_ORDER";
})(UrlSlug || (exports.UrlSlug = UrlSlug = {}));
//# sourceMappingURL=urlSlug.enum.js.map